import React from 'react';
import { Header } from '../components/Header';
import { ApproachSection } from '../components/ApproachSection';
import { BeliefSection } from '../components/BeliefSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-256">
      <Header data-id="element-257" />
      <main data-id="element-258">
        <ApproachSection data-id="element-259" />
        <BeliefSection data-id="element-260" />
        <ServicesSection data-id="element-261" />
        <WhyChooseUsSection data-id="element-262" />
        <TestimonialsSection data-id="element-263" />
        <ContactForm data-id="element-264" />
      </main>
      <Footer data-id="element-265" />
    </div>;
}